import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Microalgae are primary producers in aquatic ecosystems, which aid
              in the ecological processes of primary production, biogeochemical
              cycling, nutrient cycling, etc. The biochemical composition of
              microalgae includes high protein, fat, and carbohydrate, which
              constitute a vital raw material in the biofuel, pharmaceutical,
              and nutraceutical industries for the manufacture of biofuel, food,
              supplements, animal feedstock, medicine, bioplastics, and
              fertilizer. However, selecting appropriate strains for an
              economically viable production process is challenging,
              necessitating an exploration of commercially viable algal strains.
              The composition and assemblage of algal species reflect the
              ecological health of aquatic ecosystems and are utilized as
              bioindicators of aquatic environments, revealing their physical
              and chemical health. The present study determines the diversity
              and composition of microalgal species in lakes in the
              Hebbal-Nagavara Valley, Bangalore. The study documents microalgae
              belonging to Cyanophyta, Chlorophyta, Euglenozoa, Bacillariophyta,
              Charophyta, Ochrophyta, and Glaucophyta, with Chlorophyta being
              the dominant group. Dominance (D) varied from 0.25 to 0.55, with a
              maximum at Narsipura 2 Lake and a low at Kogilu Lake, whereas the
              Shannon diversity index ranged from 0.69 to 1.60. All
              physicochemical and microalgal data were subjected to cluster
              analysis to categorize the lakes according to their environmental
              status based on the level of contamination. Therefore, alterations
              in the physical and chemical properties of waterbodies are
              immediately reflected in the composition of the biotic community
              within the ecosystem. Microalgae-based biomonitoring is a very
              effective and cost-effective technique for determining the degree
              of pollution in water based on species assemblages.
            </p>
            <p>
              <strong>Keywords: </strong>Microalgae, Lakes, Diversity index,
              Water pollution, Bioindicator
            </p>
            <p>&nbsp;</p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
